import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=6dea7fb0&scoped=true&"
import script from "./MainTabs.vue?vue&type=script&lang=js&"
export * from "./MainTabs.vue?vue&type=script&lang=js&"
import style0 from "./MainTabs.vue?vue&type=style&index=0&id=6dea7fb0&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea7fb0",
  null
  
)

export default component.exports